import { ADVISOR } from './advisor'
import { USERS } from './users'

// Account and authentication related translations
export const ACCOUNT = {
  // Page title and menu
  accountSettings: 'Kontoeinstellungen',
  logout: 'Abmelden',

  // Section headers
  profile: 'Profil',
  loginCredentials: 'Anmeldedaten',
  devices: 'Geräte',

  // Buttons
  changeName: 'Name ändern',
  changeEmail: 'E-Mail ändern',
  changePassword: 'Passwort ändern',
  logoutAllDevices: 'Von allen Geräten abmelden',
  logoutAllDevicesHint: 'Du wirst auch von diesem Gerät abgemeldet.',

  // Change name modal
  changeNameDescription: 'Gib deinen neuen Namen ein.',
  newNamePlaceholder: 'Neuer Name',

  // Change email modal
  changeEmailDescription:
    'Gib deine neue E-Mail-Adresse zusammen mit deinem aktuellen Passwort ein.',
  newEmailPlaceholder: 'Neue E-Mail-Adresse',
  emailChangeFailed: 'Die E-Mail-Adresse konnte nicht geändert werden.',

  // Change password modal
  passwordChangeFailed: 'Das Passwort konnte nicht geändert werden.',
  changePasswordDescription: (min: number) =>
    `Gib dein neues Passwort zusammen mit deinem alten Passwort ein. Das neue Passwort braucht mindestens ${min} Zeichen.`,
  oldPasswordPlaceholder: 'Altes Passwort',
  confirmNewPasswordPlaceholder: 'Neues Passwort bestätigen',
  changePasswordWarning:
    'Achtung: Wenn du dein Passwort änderst, wirst du von allen Geräten abgemeldet!',

  errors: {
    // Resolved by `extractErrorMessage` from the `code` the server sends.
    wrongPassword: 'Das aktuelle Passwort stimmt nicht.',
  },

  // Device section
  thisDevice: 'Dieses Gerät',
  lastActive: 'Zuletzt aktiv',

  // Success messages
  emailChanged: 'E-Mail-Adresse geändert',
  passwordChanged: 'Passwort geändert',
  nameChanged: 'Name geändert',
  loggedOutAllDevices: 'Du wurdest von allen Geräten abgemeldet',

  // Advisor profile (SALES/ADMIN/ROOT)
  advisorProfile: 'Berater-Profil',
  advisorProfileDescription:
    'Diese Angaben sehen Kund:innen auf ihrer Ansprechpartner-Karte — im Kundenbereich, auf öffentlichen Projektseiten und im Konfigurator.',
  /** The row that says where an advisor's name is kept. Its words are
   *  `USERS.hubSpot` — one operation, one vocabulary. */
  advisorHubSpotLabel: USERS.hubSpot.ownedFields,
  advisorHubSpotHint: `Diese Angaben ${USERS.hubSpot.ownedBy}. Beim Übernehmen werden sie hier überschrieben.`,
  /** No contact in HubSpot, so BrickUp keeps the name itself. */
  advisorHubSpotUnlinked: `${USERS.hubSpot.unknown} — Name und Anrede werden hier gepflegt.`,
  advisorJobTitleHint: `Ohne Eintrag wird „${ADVISOR.jobTitleMale}“ bzw. „${ADVISOR.jobTitleFemale}“ verwendet.`,
  advisorPictureLabel: 'Profilbild',
  advisorPictureHint: 'Quadratisch, mindestens 300 × 300 Pixel.',
  advisorPictureAdd: 'Bild hochladen',
  advisorPictureReplace: 'Bild ersetzen',

  // Mirrored from HubSpot: maintained there, only displayed here
  advisorHubspotGroup: 'Aus HubSpot',
  advisorValueMissing: 'Nicht hinterlegt',
  advisorHubspotLinked: 'Verknüpft',
  advisorHubspotUnset: 'Nicht gefunden',
  advisorHubspotHint:
    'Diese Angaben pflegst du in HubSpot unter „Profil & Einstellungen“. BrickUp übernimmt sie automatisch, spätestens nach zehn Minuten.',
  advisorHubspotMissing: (email: string) =>
    `Zu ${email} gibt es kein HubSpot-Konto. Kund:innen sehen deshalb weder Telefonnummer noch Terminbuchung, und Suchmandate lassen sich dir nicht zuordnen.`,
  advisorPhoneMissing: 'Kund:innen sehen keine Telefonnummer.',
  advisorGenderMale: 'Männlich',
  advisorGenderFemale: 'Weiblich',
  advisorGenderMissing: `Es wird durchgehend die männliche Form verwendet: „${ADVISOR.contactPersonMale}“, „${ADVISOR.jobTitleMale}“.`,
  advisorCalendarMissing: `Der „${ADVISOR.bookAppointment}“-Button wird ausgeblendet.`,

  advisorProfileSaveError: 'Berater-Profil konnte nicht gespeichert werden',
  advisorProfileEdit: 'Berater-Profil bearbeiten',
  advisorProfileUnavailable:
    'Für diesen Nutzer ist kein Berater-Profil verfügbar.',

  // Access denied
  accessDenied: 'Zugriff verweigert',
  accessDeniedDescription:
    'Du hast keine Berechtigung, auf diese Seite zuzugreifen. Bitte kontaktiere deinen Administrator, wenn du glaubst, dass es sich um einen Fehler handelt.',
} as const
